import { scrollItemToIndex } from '@/warehouse/components/ItemWorkflowTable/helpers';
import { packingActions } from '../packing.state';
const setSelectionBySearchTerm = ({ items, searchTerm, tableVirtuosoRef, tableScrollingContainerRef }) => (dispatch, getState) => {
    dispatch(packingActions.setSelectedItemIndexBySearchTerm({ items, searchTerm }));
    const selectedItemIndex = getState().packing.packingDetails.selectedItemIndex;
    if (tableScrollingContainerRef?.current) {
        scrollItemToIndex(tableScrollingContainerRef, selectedItemIndex);
    }
    else if (tableVirtuosoRef?.current) {
        tableVirtuosoRef.current?.scrollToIndex({
            index: selectedItemIndex === -1 ? 0 : selectedItemIndex,
            align: 'center',
            behavior: 'auto',
        });
    }
};
export { setSelectionBySearchTerm };
